import { Alert, AlertTitle, Button, CircularProgress, Stack, Typography } from '@all-manager/design-system-v2';
import AuthLayout from '../../../../layout/AuthLayout/AuthLayout';
import { useGoogleDriveCallbackPage } from './useGoogleDriveCallbackPage';

export default function GoogleDriveCallbackPage() {
  const hook = useGoogleDriveCallbackPage();

  if (hook.status === 'error') {
    return (
      <AuthLayout title="Connexion Google Drive">
        <Alert severity="error">
          <AlertTitle>La connexion a échoué</AlertTitle>
          {hook.errorMessage} Réessayez depuis les paramètres de l'espace.
        </Alert>
        <Button fullWidth variant="contained" onClick={hook.handleBackToSettings}>
          Retour aux paramètres
        </Button>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Connexion Google Drive">
      <Stack direction="row" spacing={2} alignItems="center" role="status">
        <CircularProgress size="small" />
        <Typography variant="body1">
          Connexion en cours, nous configurons le compte Google Drive de l'espace.
        </Typography>
      </Stack>
    </AuthLayout>
  );
}
